export function deDupeRegExFlags(flags) {
    const deDuped = new Set(Array.from(flags.toLowerCase()));
    return Array.from(deDuped).join('');
}
export function addRegExpFlags(originalRegExp, flags) {
    return new RegExp(originalRegExp.source, deDupeRegExFlags([
        originalRegExp.flags,
        flags,
    ].join('')));
}
export function safeMatch(input, regExp) {
    const match = input.match(regExp);
    return match !== null && match !== void 0 ? match : [];
}
